"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_body_html_1 = __importDefault(require("@public-templates/widget-body.html"));
require("@services/logger-service");
angular.module('qualtrics.results')
    .directive('qWidgetBody', [
    '$rootScope',
    '$compile',
    '$routeParams',
    'rsLog',
    'rsWidgets',
    'rsEnvironment',
    '$timeout',
    'loggerService',
    function ($rootScope, $compile, $routeParams, log, rsWidgets, env, $timeout, loggerService) {
        return {
            scope: {
                widget: '=widgetModel',
                page: '=',
                containerId: '=',
                scrollInfo: '='
            },
            templateUrl: widget_body_html_1.default,
            link: function ($scope, element) {
                var wasRenderedInView = false;
                var loadingWidgetBody = false;
                var fullDataHandler = $rootScope.$on('viewresults.widgetFullDataRendered', function (ev, widgetId) {
                    if (widgetId === $scope.widget._id) {
                        wasRenderedInView = true;
                        if (!$rootScope.cachedWidgetHeights) {
                            $rootScope.cachedWidgetHeights = {};
                        }
                        $timeout(function () {
                            $rootScope.cachedWidgetHeights[widgetId] = element.height();
                            element.height('auto');
                        }, 0, false);
                    }
                });
                var scrollListener = $rootScope ? $rootScope.$on('reporting-scroll', initWhenVisible) : function () { };
                var widgetHeight = $scope.$eval('$root.cachedWidgetHeights[widget._id]');
                if (widgetHeight) {
                    element.height(widgetHeight);
                }
                $scope.$on('$destroy', function () {
                    if (scrollListener) {
                        scrollListener();
                    }
                    if (fullDataHandler) {
                        fullDataHandler();
                    }
                    var children = element.children();
                    if (children.length) {
                        children.empty();
                    }
                    rsWidgets.unload($scope.widget._id, $scope.page._id, $scope.containerId);
                });
                initWhenVisible();
                function initWhenVisible() {
                    if (wasRenderedInView) {
                        return;
                    }
                    if ($scope.scrollInfo.jumpToPage) {
                        // wrap in timeout so when jumping to a page, we can get correct relative position to viewport
                        $timeout(initIfOnScreen);
                    }
                    else {
                        initIfOnScreen();
                    }
                    function initIfOnScreen() {
                        var rect = element[0].getBoundingClientRect();
                        var onScreen = (rect.bottom >= 0 &&
                            rect.top <= (window.innerHeight || document.documentElement.clientHeight));
                        if (onScreen || $routeParams.disableInfiniteScroll) {
                            init();
                        }
                    }
                }
                function init() {
                    if (loadingWidgetBody) {
                        return;
                    }
                    loadingWidgetBody = true;
                    // If we are trying to reload the widget we need to empty the element
                    var children = element.children();
                    if (children.length) {
                        children.empty();
                    }
                    rsWidgets.ensureDependency('dependencies/viewresults/source-configuration')
                        .then(function () {
                        return rsWidgets.loadBody($scope.widget._type, $scope.widget._id, children, null, $scope.page._id, $scope.containerId)
                            .then(function () {
                            element.find('.loading-indicator').remove();
                            loggerService.info('Successfully loaded widget body in public client');
                        });
                    })
                        .catch(function (err) {
                        log.error('Error rendering widget', err);
                        loggerService.error(err);
                    })
                        .finally(function () {
                        loadingWidgetBody = false;
                    });
                }
            }
        };
    }
]);
